import { v1, toResult, type V1Result } from '@/infrastructure/api/v1/client';

// getExternalContent: a GET of a Poly Pizza or Sketchfab URL with our key added server-side, on the user's bearer

/** The JSON body an external API answers with. */
export async function getExternalJson<T>(url: string): Promise<V1Result<T>> {
  return toResult(v1.GET('/api/v1/external-content', { params: { query: { url } }, parseAs: 'json' })) as Promise<V1Result<T>>;
}

/** The bytes an external URL serves (a model file), for a blob URL a loader can open. */
export async function getExternalBlob(url: string): Promise<V1Result<Blob>> {
  return toResult(v1.GET('/api/v1/external-content', { params: { query: { url } }, parseAs: 'blob' }));
}
